module.exports = __webpack_public_path__ + "img/white_skull_icon.fb1ee787.png";